"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var localeDataseTranslations = require('@wix/locale-dataset-data/resources/translations/messages_en.json');
var locale_dataset_javascript_1 = require("@wix/locale-dataset-javascript");
var extractSubdivisionCode = function (subdivision) {
    var subdivisions = subdivision.split('-');
    if (subdivisions && subdivisions.length > 1) {
        return subdivisions[1];
    }
    return subdivision;
};
var translateLocale = function (key) {
    return localeDataseTranslations[key];
};
exports.createWixCodeAddressObject = function (address) {
    if (!address) {
        return {
            formatted: '',
        };
    }
    var wixCodeAddress = {
        formatted: '',
        city: address.city,
        country: address.country,
        addressLine: address.addressLine1,
        postalCode: address.zipCode,
        streetAddress: address.street,
        subdivision: address.subdivision,
    };
    var localizedAddress = __assign({}, address);
    var countryData = null;
    if (address.country) {
        countryData = locale_dataset_javascript_1.default.getCountryByShortKey(address.country);
        if (countryData) {
            localizedAddress.country = translateLocale(countryData.displayName);
            wixCodeAddress.country = countryData.key;
        }
        else {
            localizedAddress.country = null;
        }
    }
    if (address.subdivision) {
        var countryKey = countryData ? countryData.key : address.country;
        var subdivisionData = locale_dataset_javascript_1.default.getStateByKey(countryKey, extractSubdivisionCode(address.subdivision));
        if (subdivisionData) {
            localizedAddress.subdivision = translateLocale(subdivisionData.displayName);
            wixCodeAddress.subdivision = subdivisionData.key;
        }
        else {
            localizedAddress.subdivision = null;
        }
    }
    var formatted = locale_dataset_javascript_1.default.getFormattedAddress(localizedAddress, localizedAddress.country).trim();
    wixCodeAddress.formatted = formatted ? formatted : '';
    return wixCodeAddress;
};
exports.createPlatformizedWixCodeAddressObject = function (address) {
    if (!address) {
        return '';
    }
    var addressLine1 = address.addressLine ||
        (address.streetAddress && address.streetAddress.name + " " + address.streetAddress.number) ||
        '';
    var localizedAddress = __assign({}, address, { addressLine1: addressLine1, zipCode: address.postalCode });
    var countryData = null;
    if (address.country) {
        countryData = locale_dataset_javascript_1.default.getCountryByShortKey(address.country);
        localizedAddress.country = countryData ? translateLocale(countryData.displayName) : null;
    }
    if (address.subdivision) {
        var countryKey = countryData ? countryData.key : address.country;
        var subdivisionData = locale_dataset_javascript_1.default.getStateByKey(countryKey, extractSubdivisionCode(address.subdivision));
        localizedAddress.subdivision = subdivisionData ? translateLocale(subdivisionData.displayName) : null;
    }
    var formatted = locale_dataset_javascript_1.default.getFormattedAddress(localizedAddress, localizedAddress.country).trim();
    return formatted;
};
//# sourceMappingURL=address-utils.js.map